<template>
  <section class="relative pb-0">
    <div class="container flex flex-row justify-between">
      <div class="flex flex-row gap-12">
        <button type="button" name="next" class="cursor-pointer" @click="index -= 1" :disabled="index === 0">
          <arrow-icon
            class="w-12 h-12 transform -rotate-90"
            :class="{
              'text-blue': index !== 0,
              'text-light-grey': index === 0
            }"
          />
        </button>
        <div class="scroller">
          <transition name="fade" mode="out-in" class="scroller">
            <div :key="index" class="flex flex-col lg:flex-row items-center lg:gap-12">
              <div class="w-full lg:w-2/3 flex flex-col lg:order-2 text-center lg:text-left">
                <h2 class="mb-6">
                  {{ title }}
                </h2>
                <p class="text-p1 mb-8 lg:mb-4" v-html="subtitle" />
                <p v-if="caption" class="text-legal hidden lg:inline lg:mb-0">
                  {{ caption }}
                </p>
                <join-button
                  v-if="index === images.length - 1"
                  class="hidden lg:inline mt-8"
                  :login-path="loginPath"
                  :signup-path="signupPath"
                />
              </div>
              <div class="w-full lg:w-1/3 flex flex-col items-center justify-center lg:order-1">
                <pict :default="images[index].default" :sources="images[index].sources" class="img" />
              </div>
              <p v-if="caption" class="text-legal lg:hidden mt-6 text-center">
                {{ caption }}
              </p>
              <join-button class="lg:hidden mt-8 lg:mt-16" :login-path="loginPath" :signup-path="signupPath" />
            </div>
          </transition>
        </div>
      </div>

      <button type="button" name="previous" class="cursor-pointer" @click="index += 1" :disabled="index === 2">
        <arrow-icon
          class="w-12 h-12 transform rotate-90"
          :class="{
            'text-blue': index !== 2,
            'text-light-grey': index === 2
          }"
        />
      </button>
    </div>
  </section>
</template>

<script>
import Pict from "@/shared/pict"
import ArrowIcon from "@/component-library/icons/arrow-icon"
import JoinButton from "../join-button"

import image1 from "../../images/slider-1.png"
import image12x from "../../images/slider-1@2x.png"

import image2 from "../../images/slider-2.png"
import image22x from "../../images/slider-2@2x.png"

import image3 from "../../images/slider-3.png"
import image32x from "../../images/slider-3@2x.png"

export default {
  name: "SpacesExplainerDesktop",
  components: {
    Pict,
    ArrowIcon,
    JoinButton
  },
  props: {
    copy: {
      type: Array,
      required: true
    },
    spaceB2b: {
      type: Boolean,
      required: true
    },
    signupPath: {
      type: String,
      required: true
    },
    loginPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      index: 0
    }
  },
  computed: {
    title() {
      return this.copy[this.index].title
    },
    subtitle() {
      const itemCopies = this.copy[this.index]

      if (this.spaceB2b) {
        return "subtitleB2b" in itemCopies ? itemCopies.subtitleB2b : itemCopies.subtitle
      } else {
        return itemCopies.subtitle
      }
    },
    caption() {
      const itemCopies = this.copy[this.index]

      if (this.spaceB2b) {
        return "captionB2b" in itemCopies ? itemCopies.captionB2b : itemCopies.caption
      } else {
        return itemCopies.caption
      }
    },
    images() {
      return [
        {
          default: {
            src: image1,
            srcset: {
              "2x": image12x
            }
          },
          sources: [
            {
              media: "s",
              src: image1,
              srcset: {
                "2x": image12x
              }
            },
            {
              media: "m",
              src: image1,
              srcset: {
                "2x": image12x
              }
            }
          ]
        },

        {
          default: {
            src: image2,
            srcset: {
              "2x": image22x
            }
          },
          sources: [
            {
              media: "s",
              src: image2,
              srcset: {
                "2x": image22x
              }
            },
            {
              media: "m",
              src: image2,
              srcset: {
                "2x": image22x
              }
            }
          ]
        },

        {
          default: {
            src: image3,
            srcset: {
              "2x": image32x
            }
          },
          sources: [
            {
              media: "s",
              src: image3,
              srcset: {
                "2x": image32x
              }
            },
            {
              media: "m",
              src: image3,
              srcset: {
                "2x": image32x
              }
            }
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>
.img {
  flex-shrink: 0;
  width: 233px;
  height: 483px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity, 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
